import React, { Component } from 'react';

class Coordinates extends Component {


	setCoordinates() {

		let coordArray = this.props.coordArray.map((item, i) =>{
			console.log(item)
			return <div key={i}>[{item[0]}, {item[1]}],</div>
		})
		if(this.props.coordinates){
			return(
				<div>
					<p>[{this.props.coordinates.lng} , {this.props.coordinates.lat}] </p>
					<p>{this.props.zoom}</p>
					<div>{coordArray}</div>
				</div>
			)
		}
	}

	render() {
		// console.log(this.props.coordArray)
		return(
			<div className="Coordinates" onClick={()=>{this.props.scrollHandler()}}>	
				{this.setCoordinates()}
			</div>
		)
	}

}

export default Coordinates;


// WEBPACK FOOTER //
// ./src/components/Coordinates.js